<template>
  <vx-tooltip :text="$t('listen')" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      type="border"
      @click="process">
      <i class="c-icon-listen"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'CtiListen',
  props: {
    server: {
      required: true
    },
    isDisplay: {
      default: false
    }
  },
  computed: {
    phoneNumber () {
      return this.$store.getters.phoneNumber
    },
    extension () {
      return this.$store.getters.extension
    }
  },
  methods: {
    process () {
      if (this.isDisplay) {
        return
      }

      if (this.phoneNumber === null || this.phoneNumber.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Phone Number is Required.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      const data = {
        extension: this.extension,
        channel: this.phoneNumber
      }

      try {
        Cti.listen(this.server.domain, data)
        this.$vs.notify({
          title:'CTI Notice',
          text:`${this.phoneNumber} 감청 시작`,
          color:'danger',
          position:'top-right'
        })
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Listen Error',
          color:'danger',
          position:'top-right'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
